<template>
  <div class="service-list-card" :class="{ vertical: isVertical }">
    <div class="title" v-if="!isVertical">
      我的服务
    </div>
    <div class="service-list">
      <template v-for="(item, i) in serviceList">
        <div class="list-item" :key="i" v-if="item.show">
          <div class="icon-wrapper">
            <img class="icon" :src="item.icon" />
            <div>{{ item.name }}</div>
          </div>
          <div class="icon-wrapper" v-if="isVertical">
            <span class="hmicon icon-youjiantou"></span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVertical: {
      type: Boolean,
      default: false
    },
    serviceList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.service-list-card {
  background: #fff;
  border-radius: 3px;
  margin: 15px;
  font-size: 14px;
  &::before {
    display: table;
    content: "";
  }
  .title {
    margin: 20px 10px;
    font-size: 16px;
  }
  &.vertical {
    .service-list {
      display: unset;
      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 0;
        .icon-wrapper {
          display: flex;
          align-items: center;
        }
        .hmicon {
          font-size: 14px;
        }
        .icon {
          width: 15px;
          height: auto;
          margin-right: 10px;
        }
      }
    }
  }
  .service-list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      flex-basis: 25%;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
      .icon {
        height: 30px;
        width: auto;
      }
    }
  }
}
</style>
